import {BrowserModule} from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, inject, provideAppInitializer } from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SideNavModule} from './components/side-nav/side-nav.module';
import {DashboardModule} from './components/dashboard/dashboard.module';
import {AuthGuardService} from './services/auth-guard.service';
import {CookieService} from 'ngx-cookie-service';
import {SiteModule} from './components/site/site.module';
import {SiteService} from './services/site/site.service';
import {ToastComponent} from './components/shared/toast/toast-global.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faHamburger} from '@fortawesome/free-solid-svg-icons';
import {AboutModule} from './components/shared/about/about.module';
import {FormsModule} from '@angular/forms';
import {ProgramModule} from './components/program/program.module'; /**/
import {CanDeactivateGuard} from './services/can-deactivate-guard.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {CalibrantLoadModule} from "./components/shared/calibrant-load/calibrant-load.module";
import {SiteHomeModule} from "./components/site/site-home/site-home.module";
import {MatSidenavModule} from "@angular/material/sidenav";
import {NavResourceService} from "./services/nav-resource.service";
import {MatToolbarModule} from "@angular/material/toolbar";
// @ts-ignore
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {ControlModule} from "./components/control/control.module";
import {MatNativeDateModule} from "@angular/material/core";
import {CalibrantFooterModule} from "./components/calibrant-footer/calibrant-footer.module";
import {ResourceService} from "./services/resource.service";
import {NgOptimizedImage} from "@angular/common";
import {GoogleService} from "./services/google.service";
import {firstValueFrom, Observable} from "rxjs";
import {LoginRedirectService} from "./services/login-redirect.service";
import {PermissionService} from "./services/permission.service";
import {authInterceptor, errorInterceptor} from "./interceptors";
import {IconsService} from "./services/icon.service";
import { NavbarService } from './services/navbar.service';

library.add(faHamburger);

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SideNavModule,
    NgbModule,
    DashboardModule,
    SiteHomeModule,
    SiteModule,
    AboutModule,
    ProgramModule,
    ControlModule,
    FontAwesomeModule,
    FormsModule,
    CalibrantLoadModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatNativeDateModule,
    CalibrantFooterModule,
    NgOptimizedImage,
  ],
  providers: [
    AuthGuardService,
    CanDeactivateGuard,
    CookieService,
    IconsService,
    SiteService,
    NavResourceService,
    ResourceService,
    provideAppInitializer(async () => {
      const loginService = inject(LoginRedirectService);
      const navbarService = inject(NavbarService);
      const googleService = inject(GoogleService);
      const permissionsService = inject(PermissionService);
      const iconService = inject(IconsService);
      await loginService.loadLoginPage();
      await navbarService.url();
      const permissionsPromise = firstValueFrom(permissionsService.getPermissions());
      const apiKeyPromise = firstValueFrom(googleService.load());
      const iconsPromise = firstValueFrom(iconService.load());
      return await Promise.all([apiKeyPromise, permissionsPromise, iconsPromise]);
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
}
